import { useState } from "react";
import { Phone, Menu, X, ExternalLink, ArrowRight } from "lucide-react";
import { useSite } from "@/lib/site";
import { telHref } from "@/lib/api";
import { Logo } from "./Logo";

export const Wordmark = Logo;

const NAV = [
  { href: "/#how-it-works", label: "How it works", id: "nav-how-link" },
  { href: "/#faqs", label: "FAQs", id: "nav-faqs-link" },
  { href: "/#contact", label: "Contact", id: "nav-contact-link" },
];

export const SiteHeader = () => {
  const { cfg } = useSite();
  const b = cfg.business;
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-3 py-2 max-[359px]:px-2 sm:gap-4 sm:px-6 sm:py-4">
        <Logo />
        <nav className="hidden items-center gap-7 text-sm font-medium text-brand-charcoal lg:flex" aria-label="Main">
          {NAV.map((n) => <a key={n.id} href={n.href} className="hover:text-primary" data-testid={n.id}>{n.label}</a>)}
          <a href={b.stock_url} className="inline-flex items-center gap-1 hover:text-primary" data-testid="nav-browse-cars-link">
            Browse our cars <ExternalLink className="h-3.5 w-3.5" aria-hidden />
          </a>
        </nav>
        <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
          <a href={telHref(b.phone)} data-testid="header-phone-link"
             className="inline-flex min-h-[44px] items-center gap-1.5 rounded-md border border-slate-300 px-2 text-sm font-semibold text-brand-navy hover:border-brand-navy sm:gap-2 sm:px-3">
            <Phone className="h-4 w-4" aria-hidden /><span className="hidden sm:inline">{b.phone}</span><span className="max-[359px]:sr-only sm:hidden">Call</span>
          </a>
          <a href="/#valuation" className="btn-cta hidden min-h-[44px] items-center gap-1.5 rounded-md px-4 text-sm font-semibold lg:inline-flex" data-testid="header-get-valuation-button">
            Get a valuation <ArrowRight className="h-4 w-4" aria-hidden />
          </a>
          <button type="button" className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-slate-300 lg:hidden"
                  onClick={() => setOpen(!open)} aria-expanded={open} aria-label="Menu" data-testid="mobile-menu-button">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-border bg-white px-4 py-2 lg:hidden" aria-label="Mobile">
          {NAV.map((n) => <a key={n.id} href={n.href} onClick={() => setOpen(false)} className="block py-3 font-medium" data-testid={`mobile-${n.id}`}>{n.label}</a>)}
          <a href={b.stock_url} className="block py-3 font-medium text-primary" data-testid="mobile-browse-cars-link">Browse our cars</a>
        </nav>
      )}
    </header>
  );
};
